import { gql } from '@apollo/client';

const SAVE_SIGNATURE_DATE_TO_REPORT_MUTATION = gql`
  mutation saveSignatureDateToReport($id: ID!, $signatureDate: DateTime!, $signatureUTC: String) {
    saveSignatureDateToReport(id: $id, signatureDate: $signatureDate, signatureUTC: $signatureUTC) {
      isSuccess
      message
    }
  }
`;

export default SAVE_SIGNATURE_DATE_TO_REPORT_MUTATION;
